<template>
  <div class="whiteboard-control">
    <div
      :class="['menu', { 'active': drawState === 'pencil' }]"
      @click="$emit('onClickPencil')"
    >
      <span class="menu-tooltip">{{ $t('pages.room.boardTooltip.pencil') }}</span>
      <img :src="require('@/assets/images/room/icons/pencil.png')"/>
    </div>
    <div
      class="menu"
      @click="thicknessStateSubMenu = !thicknessStateSubMenu"
      v-click-outside="() => thicknessStateSubMenu = false"
    >
      <span v-show="!thicknessStateSubMenu" class="menu-tooltip">{{ $t('pages.room.boardTooltip.thickness') }}</span>
      <img :src="require(`@/assets/images/room/icons/thickness_state_${thicknessState}.png`)"/>
      <div
        v-show="thicknessStateSubMenu"
        class="sub-menus">
        <div
          :class="['menu', { 'active': thicknessState === 'light' }]"
          @click="$emit('onClickThickness', 'light')"
        >
          <img :src="require('@/assets/images/room/icons/thickness_light.png')"/>
        </div>
        <div
          :class="['menu', { 'active': thicknessState === 'normal' }]"
          @click="$emit('onClickThickness', 'normal')"
        >
          <img :src="require('@/assets/images/room/icons/thickness_normal.png')"/>
        </div>
        <div
          :class="['menu', { 'active': thicknessState === 'bold' }]"
          @click="$emit('onClickThickness', 'bold')"
        >
          <img :src="require('@/assets/images/room/icons/thickness_bold.png')"/>
        </div>
      </div>
    </div>
    <div
      class="menu"
      @click="colorHexSubMenu = !colorHexSubMenu"
      v-click-outside="() => colorHexSubMenu = false"
    >
      <span class="color">
        <span v-show="!colorHexSubMenu" class="menu-tooltip">{{ $t('pages.room.boardTooltip.color') }}</span>
        <span
          :class="['color-inner', { 'color-border': colorHex == '#FFFFFF' }]"
          :style="`background-color: ${colorHex};`"
        />
        <div
          v-show="colorHexSubMenu"
          class="sub-menus color-picker">
          <div
            v-for="(color, index) in colors"
            :key="index"
            :class="['menu', { 'active': color === colorHex }]"
            @click="$emit('onClickPickerColor', color)"
          >
            <span class="color">
              <span
                :class="['color-inner', { 'color-border': color == '#FFFFFF' }]"
                :style="`background-color:${color};`"/>
            </span>
          </div>
        </div>
      </span>
    </div>
    <div
      :class="['menu', { 'active': drawState === 'eraser' }]"
      @click="$emit('onClickEraser')"
    >
      <span v-show="!colorHexSubMenu" class="menu-tooltip">{{ $t('pages.room.boardTooltip.eraser') }}</span>
      <img :src="require('@/assets/images/room/icons/eraser.png')"/>
    </div>
    <div
      class="menu"
      @click="$emit('onClickTrash')"
    >
      <span v-show="!colorHexSubMenu" class="menu-tooltip">{{ $t('pages.room.boardTooltip.trash') }}</span>
      <img :src="require('@/assets/images/room/icons/trash.png')"/>
    </div>
    <span class="menu-boder"/>
    <div
      v-if="$deviceInfo.isSupportedShare"
      :class="['menu', {
        'active': screenShareState === 1,
        'disabled': screenShareState === 2
      }]"
      @click="$emit('onClickScreenShare')"
    >
      <span v-show="!colorHexSubMenu" class="menu-tooltip">{{ $t('pages.room.tooltip.screenShare') }}</span>
      <img :src="require('@/assets/images/room/icons/screen_share_board.png')"/>
    </div>
    <div
      class="menu"
      @click="$emit('onClickSnapshot')"
    >
      <span v-show="!colorHexSubMenu" class="menu-tooltip">{{ $t('pages.room.boardTooltip.snapshot') }}</span>
      <img :src="require('@/assets/images/room/icons/snapshot.png')"/>
    </div>
    <div
      class="menu"
      @click="$emit('onClickDisplaySize')"
    >
      <span v-show="!colorHexSubMenu" class="menu-tooltip">{{ $t(`pages.room.boardTooltip.${expanded ? 'contract' : 'expand'}`) }}</span>
      <img :src="require(`@/assets/images/room/icons/${expanded ? 'contract' : 'expand'}.png`)"/>
    </div>
  </div>
</template>

<script>
import ClickOutside from 'vue-click-outside'

export default {
  name: 'WhiteboardControl',
  props: {
    drawState: {
      type: String,
      default: 'pencil'
    },
    thicknessState: {
      type: String,
      default: 'normal'
    },
    colorHex: {
      type: String,
      default: '#000000'
    },
    screenShareState: {
      type: Number,
      default: 0
    },
    expanded: Boolean
  },
  directives: {
    ClickOutside
  },
  computed: {
    colors: () => {
      return [
        '#000000',
        '#FFFFFF',
        '#666666',
        '#FF0000',
        '#0064FF',
        '#FFE600',
        '#00C800',
        '#FF6496',
        '#960096'
      ]
    }
  },
  data() {
    return {
      thicknessStateSubMenu: false,
      colorHexSubMenu: false
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/variables";
@import "@/styles/mediaquery";

.whiteboard-control {
  z-index: 3;
  position: absolute;
  padding: 10px 6px;
  background-color: white;
  border-radius: 4px;
  box-shadow: 0px 0px 10px #00000033;
  transition: opacity 0.3s;
  display: flex;
  justify-content: center;
  align-items: center;
  top: calc(100% + 10px);
  left: 50%;
  transform: translate(-50%, 0);

  @include mq(md) {
    pointer-events: none;
    top: 10px;
    left: 10px;
    transform: translate(0);
    display: block;
    opacity: 0;

    &:hover {
      opacity: 1 !important;
    }
  }

  .menu {
    display: flex;
    align-items: center;
    position: relative;
    cursor: pointer;
    padding: 6px;
    border-radius: 4px;
    margin-bottom: 0;

    @include mq(md) {
      margin-bottom: 10px;

      &:last-child {
        margin-bottom: 0;
      }

      &:hover .menu-tooltip {
        display: block;
      }
    }

    &:hover:not(.disabled):not(.exit) {
      background-color: $light-gray-color;
    }

    &.active {
      background-color: $light-border-color;
    }

    &.disabled {
      opacity: 0.5;
      cursor: default;
      pointer-events: none;
    }

    .menu-tooltip {
      display: none;
      position: absolute;
      width: max-content;
      padding: 4px 6px;
      border-radius: 4px;
      left: calc(100% + 12px);
      background-color: #505050;
      color: $background-color;
    }

    img, .color {
      width: 26px;
      height: 26px;
    }

    .color {
      display: flex;
      justify-content: center;
      align-items: center;

      .color-inner {
        display: block;
        width: 50%;
        height: 50%;

        &.color-border {
          border: 1px solid black;
        }
      }
    }
  }

  .menu-boder {
    display: block;
    width: 100%;
    height: 0.5px;
    margin-bottom: 10px;
    background-color: #666666;
  }

  .sub-menus {
    position: absolute;
    left: 0;
    top: calc(100% + 10px);
    padding: 6px;
    background-color: white;
    border-radius: 4px;
    box-shadow: 0px 0px 10px #00000033;
    display: flex;

    @include mq(md) {
      left: calc(100% + 6px + 10px);
      top: 6px;
    }

    .menu {
      margin-bottom: 0;
      margin-right: 6px;

      &:last-child {
        margin-right: 0;
      }
    }

    &.color-picker {
      width: 138px;
      flex-wrap: wrap;
      justify-content: space-around;

      .menu {
        margin-right: 0;
      }
    }
  }
}
</style>
